import { PropsWithChildren, CSSProperties } from "react";

/**
 * A custom action button with dark blue background and green text
 * Based on OutlineButton but with custom styling
 */
const CustomActionButton = ({
  type,
  className,
  children,
  disabled,
  onClick,
  style
}: PropsWithChildren<{
  type?: "button" | "submit" | "reset";
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
  style?: CSSProperties;
}>) => (
  <button
    type={type || "button"}
    disabled={disabled}
    className={
      "flex items-center justify-center rounded-lg border-[1px] px-5 py-3 text-sm transition " +
      "bg-[#010D2C] text-[#58CC02] border-[#010D2C] " +
      "hover:bg-[#1a2a4a] hover:text-[#6bcc1a] hover:border-[#1a2a4a] " +
      "disabled:bg-gray-200 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-default " +
      className
    }
    style={style}
    onClick={onClick}
  >
    {children}
  </button>
);

export default CustomActionButton;
